import { Spinner } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import { BackArrow } from './Subscriptions/BackArrow';
import { SubscriptionsList } from './SubscriptionsList';
import * as styles from './styles/subscriptionsSection.css';
import { IGetSubscriptionsResponseSchema } from '../../../repositories/subscriptions/entities/schemas/GetSubscriptionsResponseSchema';
import { TActiveScreen } from '../../../store/activeScreen';
import { IFailedAction } from '../../../store/failedAction';
import { ESubscriptionsStatus } from '../../../store/subscriptions';
import { Button } from '../../base/Button';
import { Header } from '../../base/Header';

export type TFrequenciesList = { value: string; label: string }[];

export interface ISubscriptionsSectionStoreProps {
  failedAction: IFailedAction | null;
  subscriptions: IGetSubscriptionsResponseSchema | null;
  status: ESubscriptionsStatus;
  titleSubscribedOn: string;
  modalSubscribedOn: React.ReactNode | false;
}

export interface ISubscriptionsSectionDispatchProps {
  changeActiveScreen(activeScreen: TActiveScreen): void;
  removeFailedAction(): void;
  getSubscriptionList(categoryName: string, offset: number): void;
  closeModalSubscribedOn(): void;
}

export interface ISubscriptionsSectionOwnProps {
  isMobileLayout?: boolean;
  isActiveScreen?: boolean;
}

export type ISubscriptionsSectionProps = ISubscriptionsSectionStoreProps &
  ISubscriptionsSectionDispatchProps &
  ISubscriptionsSectionOwnProps;

const ERROR_SHOW_TIMEOUT = 4000;

export class SubscriptionsSection extends React.Component<ISubscriptionsSectionProps, {}> {
  private errorTimer: number;

  public componentDidUpdate() {
    const { failedAction, removeFailedAction } = this.props;

    if (failedAction) {
      if (this.errorTimer) {
        clearTimeout(this.errorTimer);
      }
      this.errorTimer = window.setTimeout(removeFailedAction, ERROR_SHOW_TIMEOUT);

      return;
    }

    if (!failedAction && this.errorTimer) {
      clearTimeout(this.errorTimer);
    }
  }

  public render() {
    if (!this.props.subscriptions) {
      return null;
    }

    const { isMobileLayout, changeActiveScreen, isActiveScreen, failedAction, status, modalSubscribedOn } = this.props;
    const { title, subscriptions, total: totalRaw, searchText, searchUrl } = this.props.subscriptions;
    const isEmptyList = subscriptions?.length === 0;
    const total = totalRaw || 0;

    return (
      <div
        className={cx(styles['subscriptions_section'], !isActiveScreen && styles['hide'])}
        data-testid="SubscriptionsSection"
      >
        {status === ESubscriptionsStatus.Loading && (
          <div className={styles['preloader']} data-testid="Preloader">
            <span>
              <Spinner size={32} id={`subscriptions_section_preloader${isMobileLayout ? '_mobile' : ''}`} />
            </span>
          </div>
        )}
        {modalSubscribedOn}
        <Header padded centered>
          <BackArrow onClick={() => changeActiveScreen('categoriesGroups')} />
          <div data-testid="Title">
            {title}
            {total > 0 && <span className={styles['count']}>{total}</span>}
          </div>
        </Header>
        {isEmptyList && (searchUrl || searchText) && (
          <div className={styles['subscriptions_empty']} data-testid="SubscriptionsEmpty">
            {searchText && (
              <div className={styles['subscriptions_empty_text']} data-testid="SubscriptionsEmptyText">
                {searchText}
              </div>
            )}

            {searchUrl && (
              <Button As="a" href={this.getRedirectUrl(searchUrl)} target="_blank" type="secondary">
                Найти
              </Button>
            )}
          </div>
        )}
        {!isEmptyList && (
          <SubscriptionsList
            isMobileLayout={isMobileLayout}
            status={status}
            subscriptions={this.props.subscriptions}
            failedAction={failedAction}
            getSubscriptionList={this.props.getSubscriptionList}
          />
        )}
      </div>
    );
  }

  private getRedirectUrl = (searchUrl: string | null) => {
    if (!searchUrl) {
      return '';
    }

    const regex = /^\//;
    const sanitizedUrl = searchUrl.search(regex) === 0 ? searchUrl : `/${searchUrl}`;

    return location.origin.concat(sanitizedUrl);
  };
}
